// extracted by mini-css-extract-plugin
export var switcher__element = "item-module--switcher__element--WhCHN";
export var active = "item-module--active--WuRe7";
export var switcher__element_disabled = "item-module--switcher__element_disabled--I6Vch";
export var element__header = "item-module--element__header--QEhSG";
export var element__header__icon = "item-module--element__header__icon--FpITc";
export var element__header__title = "item-module--element__header__title--Pz+Q6";
export var element__description = "item-module--element__description--eoC-F";